import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { ISimApnModel } from '@apps-common/types/management/sim-apn'

export const MANAGEMENT_QUERY_KEY_SEARCH_SIM_APNS = (search?: string) => ['searchSimApns', search].filter(Boolean)

export const searchSimApns = async (search?: string): Promise<ISimApnModel[]> =>
  axios.get(`/management/simapn/SearchSimApns?search=${search || ''}`).then((res) => res.data?.data)

type QueryFnType = typeof searchSimApns

type Props = {
  config?: QueryConfig<QueryFnType>
  search?: string
}

export const useManagementSearchSimApns = ({ config, search }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: MANAGEMENT_QUERY_KEY_SEARCH_SIM_APNS(search),
    queryFn: () => searchSimApns()
  })
